import styled from 'styled-components';
import { media } from '@prisjakt/ui-base';

export const Lightbox = styled.div(
  {
    width: '100%',
    maxWidth: '1024px',
    maxHeight: '90vh',
    padding: '40px',

    '.pj-ui-carousel': {
      outline: 'none',
    },
  },

  media.smallOnly({
    top: 0,
    width: '100%',
    height: '100%',
    maxHeight: 'none',
    borderRadius: 'unset',
  })
);
